module.exports = __webpack_public_path__ + "img/emotion-style@2x.6560de8.jpg";